let payNowStepOneResponse = null;
let payNowStepOneData = null;

const api = {
  checkInvoiceStatusEndpoint: 'https://app.lrlos.com/webhook/Check-Invoice-status',
  emailLookupEndpoint: 'https://app.lrlos.com/webhook/Pay-Now-Look-up',
  generatePayNowLinkByCustomerIdEndpoint: 'https://app.lrlos.com/webhook/Pay-Now-Generate-Link',
  getSubscriptionsByCustomerIdEndpoint: 'https://app.lrlos.com/webhook/Get-Subscriptions',
  payFutureInvoiceEndpoint: 'https://app.lrlos.com/webhook/Pay-future-Invoice',
}

const showPayNowConfirmationPopup = (subscription, callback) => {
  showPayNowConfirmationPopupContainer();
  openPayNowConfirmationPopupMain(subscription, callback);

  return false;
}

const showPayNowMain = () => {
  const payNowMainContainer = document.getElementById('pay-now-main-container');
  const payNowMain = document.getElementById('pay-now-main');
  const payNowStepOne = document.getElementById('pay-now-main-step-one');
  const payNowStepTwo = document.getElementById('pay-now-main-step-two');
  const payNowStepThree = document.getElementById('pay-now-main-step-three');
  const payNowStepFour = document.getElementById('pay-now-main-step-four');

  const payNowStepOneFormButton = document.getElementById('pay-now-main-step-one-form-button');

  const payNowStepFourPaymentDetailsSubscriptionInfo = document.getElementById('pay-now-main-step-four-payment-details-subscription-info');
  const payNowStepFourPaymentDetailsAmountPaid = document.getElementById('pay-now-main-step-four-payment-details-amount-paid');
  const payNowStepFourPaymentDetailsProcessedOn = document.getElementById('pay-now-main-step-four-payment-details-processed-on');
  const payNowStepFourReceiptInfoEmailDisplay = document.getElementById('pay-now-main-step-four-receipt-info-email-display');

  payNowMainContainer.style.display = 'flex';

  payNowStepOne.style.display = 'flex';
  payNowStepTwo.style.display = 'none';
  payNowStepThree.style.display = 'none';
  payNowStepFour.style.display = 'none';

  payNowStepOneFormButton.innerHTML = 'PAY NOW'
  payNowStepOneFormButton.disabled = false;

  payNowStepFourPaymentDetailsSubscriptionInfo.innerText = '';
  payNowStepFourPaymentDetailsAmountPaid.innerText = '';
  payNowStepFourPaymentDetailsProcessedOn.innerText = '';
  payNowStepFourReceiptInfoEmailDisplay.innerText = '';

  payNowMain.addEventListener('click', (e) => {
    e.stopPropagation();
  });
}

const showPayNowMainStepTwo = async (customerData, accountsList) => {
  const payNowStepOne = document.getElementById('pay-now-main-step-one');
  const payNowStepTwo = document.getElementById('pay-now-main-step-two');
  const payNowStepThree = document.getElementById('pay-now-main-step-three');
  const payNowStepTwoEmailDisplay = document.getElementById('pay-now-main-step-two-email');
  const payNowStepTwoAccountsList = document.getElementById('pay-now-main-step-two-accounts-list');
  const payNowStepTwoLoader = document.getElementById('pay-now-main-step-two-loader');

  payNowStepOne.style.display = 'none';
  payNowStepTwo.style.display = 'flex';
  payNowStepThree.style.display = 'none';
  payNowStepTwoLoader.style.display = 'flex';
  payNowStepTwoAccountsList.style.display = 'none';

  payNowStepTwoEmailDisplay.innerText = customerData.email;
  payNowStepTwoAccountsList.innerHTML = '';

  for (let i = 0; i < accountsList.length; i++) {
    const entry = accountsList[i];

    let invoiceStatus = await fetch(
      `${api.checkInvoiceStatusEndpoint}?customerID=${entry.customer_id}`,
      {
        headers: {
          'Authorization': 'whY-tSR2E12Y9QEIaZ9z'
        }
      }
    );

    invoiceStatus = await invoiceStatus.json();

    const listItem = document.createElement('li');
    const button = document.createElement('button');

    button.addEventListener('click', async () => {
      if (invoiceStatus.hasUnpaidInvoices) {
        payNowStepTwoLoader.style.display = 'flex';
        payNowStepTwoAccountsList.style.display = 'none';

        let paymentLinkResult = await fetch(
          `${api.generatePayNowLinkByCustomerIdEndpoint}?Custumer_id=${entry.customer_id}`,
          {
            headers: {
              'Authorization': 'whY-tSR2E12Y9QEIaZ9z'
            }
          }
        );

        paymentLinkResult = await paymentLinkResult.json();
        window.location.href = paymentLinkResult.hosted_page.url;
      } else {
        showPayNowMainStepThree(entry);
      }
    });

    if (invoiceStatus.hasUnpaidInvoices) {
      button.innerHTML = `
        <span>
          ${entry.first_name} ${entry.last_name}. #${entry.customer_id}
        </span>

        <span class="pay-now-main-step-two-accounts-list-unpaid-tag">Unpaid</span>

        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
    } else {
      button.innerHTML = `
        <span>
          ${entry.first_name} ${entry.last_name}. #${entry.customer_id}
        </span>

        <span class="pay-now-main-step-two-accounts-list-paid-tag">Pay Early</span>

        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
    }

    listItem.appendChild(button);
    payNowStepTwoAccountsList.appendChild(listItem);
  }

  payNowStepTwoLoader.style.display = 'none';
  payNowStepTwoAccountsList.style.display = 'block';
}

const showPayNowMainStepThree = async (account) => {
  const payNowStepTwo = document.getElementById('pay-now-main-step-two');
  const payNowStepThree = document.getElementById('pay-now-main-step-three');
  const payNowStepThreeLoader = document.getElementById('pay-now-main-step-three-loader');
  const payNowStepThreeError = document.getElementById('pay-now-main-step-three-error');
  const payNowStepThreeSubscriptionsList = document.getElementById('pay-now-main-step-three-subscriptions-list');
  const payNowStepThreeSubscriptionsListItemResidentialMonthly = document.getElementById('pay-now-main-step-three-subscriptions-list-item-residential-monthly');
  const payNowStepThreeSubscriptionsListItemResidentialYearly = document.getElementById('pay-now-main-step-three-subscriptions-list-item-residential-yearly');
  const payNowStepThreeSubscriptionsListItemTravelMonthly = document.getElementById('pay-now-main-step-three-subscriptions-list-item-travel-monthly');
  const payNowStepThreeSubscriptionsListItemTravelYearly = document.getElementById('pay-now-main-step-three-subscriptions-list-item-travel-yearly');
  const payNowStepThreePayNowButton = document.getElementById('pay-now-main-step-three-pay-now-button');
  let payNowStepThreeSubscriptionsListItemRadioInputs;
  let payNowMainStepThreeSubscriptionListItems;

  payNowStepTwo.style.display = 'none';
  payNowStepThreeSubscriptionsList.style.display = 'none';
  payNowStepThreeSubscriptionsList.innerHTML = '';
  payNowStepThreeError.style.display = 'none';
  payNowStepThreePayNowButton.style.display = 'none';
  payNowStepThree.style.display = 'flex';
  payNowStepThreeLoader.style.display = 'flex'

  let subscriptions = await fetch(
    `${api.getSubscriptionsByCustomerIdEndpoint}?customer_id=${account.customer_id}`,
    {
      headers: {
        'Authorization': 'whY-tSR2E12Y9QEIaZ9z'
      }
    }
  );

  if (subscriptions.status === 200) {
    subscriptions = await subscriptions.json();
    subscriptions = subscriptions[0];

    if (!subscriptions) {
      Toastify({
        text: "No subscriptions found for this account",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      showPayNowMainStepTwo(payNowStepOneData, payNowStepOneResponse);
    }
    else if (subscriptions.error_code) {
      Toastify({
        text: `An error occured with code: ${subscriptions.error_code}`,
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      showPayNowMainStepTwo(payNowStepOneData, payNowStepOneResponse);
    } else if (subscriptions.error) {
      Toastify({
        text: `An error occured with code: ${subscriptions.error}`,
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      showPayNowMainStepTwo(payNowStepOneData, payNowStepOneResponse);
    } else {
      const activeSubscriptions = subscriptions.activeSubscriptions;
      let selectedSubscriptionId = activeSubscriptions[0].subscription_id;
      let selectedPlanName = activeSubscriptions[0].item_price_id.split('USD')[0].replaceAll('-', ' ').toLowerCase();
      let selectedPlanAmount = activeSubscriptions[0].amount / 100;

      activeSubscriptions.forEach((subscription) => {
        if (subscription.status === 'active') {
          payNowStepThreeSubscriptionsList.innerHTML += `
            <li
              class="pay-now-main-step-three-subscriptions-list-item"
              id="pay-now-main-step-three-subscriptions-list-item-${subscription.subscription_id}"
            >
              <button>
                <div>
                  <label
                    class="pay-now-main-step-three-subscriptions-list-item-radio"
                  >
                    <input
                      class="pay-now-main-step-three-subscriptions-list-item-radio-input"
                      data-parent-id="pay-now-main-step-three-subscriptions-list-item-${subscription.subscription_id}"
                      data-plan-name="${subscription.item_price_id.split('USD')[0].replaceAll('-', ' ').toLowerCase()}"
                      data-plan-amount="$${subscription.amount / 100}"
                      data-subscription-id=${subscription.subscription_id}
                      name="pay-now-main-step-three-subscriptions-list-item"
                      type="radio"
                    >
                    <span class="pay-now-main-step-three-subscriptions-list-item-checkmark"></span>
                  </label>
                </div>

                <div class="pay-now-main-step-three-subscriptions-list-item-main-content">
                  <h4>
                    ${subscription.item_price_id.split('USD')[0].replaceAll('-', ' ').toLowerCase()}

                    <span>Active</span>
                  </h4>
                  <p>${subscription.item_price_id.split('USD')[1].replaceAll('-', ' ').toLowerCase()}</p>
                  <h3>$${subscription.amount / 100} / ${subscription.item_price_id.split('USD')[1].replaceAll('-', ' ').toLowerCase().slice(0, -2)}</h3>
                  <div>
                    <p>Renews ${getDateStringFromTimestamp(subscription.next_billing_at)}</p>
                    <a
                      class="pay-now-main-step-three-subscriptions-list-item-main-content-view-more-trigger"
                      data-details-id="pay-now-main-step-three-subscriptions-list-item-main-content-details-${subscription.subscription_id}"
                      href="#"
                    >
                      View details
                      <span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M4 6L8 10L12 6" stroke="#535259" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                    </a>
                  </div>

                  <ul
                    class="pay-now-main-step-three-subscriptions-list-item-main-content-details"
                    id="pay-now-main-step-three-subscriptions-list-item-main-content-details-${subscription.subscription_id}"
                  >
                    <li>
                      <p>Subscription ID</p>
                      <p>${subscription.subscription_id}</p>
                    </li>
                    <li>
                      <p>Modem ICCID</p>
                      <p>${subscription.cf_Device_IMEI || '-'}</p>
                    </li>
                    <li>
                      <p>Modem IMEI</p>
                      <p>${subscription.cf_SIM_ID_ICCID || '-'}</p>
                    </li>
                  </ul>
                </div>
              </button>
            </li>
          `
        }
      })

      payNowStepThreeLoader.style.display = 'none'
      payNowStepThreeSubscriptionsList.style.display = 'flex'

      payNowStepThreeSubscriptionsListItemRadioInputs = document.querySelectorAll('.pay-now-main-step-three-subscriptions-list-item-radio-input');
      payNowStepThreeSubscriptionsListItemMainContentViewMoreTriggers = document.querySelectorAll('.pay-now-main-step-three-subscriptions-list-item-main-content-view-more-trigger');

      payNowStepThreeSubscriptionsListItemRadioInputs.forEach((input) => {
        input.addEventListener('change', (e) => {
          selectedPlanName = e.target.dataset.planName;
          selectedPlanAmount = e.target.dataset.planAmount;
          selectedSubscriptionId = e.target.dataset.subscriptionId;

          const payNowMainStepThreeSubscriptionListItems = document.querySelectorAll('.pay-now-main-step-three-subscriptions-list-item');

          payNowMainStepThreeSubscriptionListItems.forEach((item) => {
            item.classList.remove('pay-now-main-step-three-subscriptions-list-item-active');
          })

          const parentElement = document.getElementById(e.target.dataset.parentId);
          parentElement.classList.add('pay-now-main-step-three-subscriptions-list-item-active')
        })
      })

      payNowStepThreeSubscriptionsListItemMainContentViewMoreTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          const detailsElementId = trigger.dataset.detailsId;
          const detailsElement = document.getElementById(detailsElementId);
          const iconContainer = trigger.querySelector('span');

          if (detailsElement.style.display == 'block') {
            detailsElement.style.display = 'none';
            iconContainer.style.transform = 'rotate(0deg)';
          } else {
            detailsElement.style.display = 'block';
            iconContainer.style.transform = 'rotate(180deg)';
          }
        })
      })

      payNowMainStepThreeSubscriptionListItems = document.querySelectorAll('.pay-now-main-step-three-subscriptions-list-item');
      payNowMainStepThreeSubscriptionListItems[0].classList.add('pay-now-main-step-three-subscriptions-list-item-active')

      payNowStepThreeSubscriptionsListItemRadioInputs[0].checked = true;

      payNowStepThreePayNowButton.style.display = 'flex';
      payNowStepThreePayNowButton.addEventListener('click', () => {
        showPayNowConfirmationPopup(activeSubscriptions.find((s) => s.subscription_id === selectedSubscriptionId), async () => {
          payNowStepThreeError.style.display = 'none';
          payNowStepThreePayNowButton.innerHTML = `<div class="bar-loader"></div>`;
          let response = await fetch(
            `${api.payFutureInvoiceEndpoint}?subID=${selectedSubscriptionId}`,
            {
              headers: {
                'Authorization': 'whY-tSR2E12Y9QEIaZ9z'
              }
            }
          )

          response = await response.json();

          payNowStepThreePayNowButton.innerHTML = `PAY NOW`;

          if (response.error_code) {
            payNowStepThreeError.innerText = response.message;
            payNowStepThreeError.style.display = 'block';
            payNowStepThreeError.scrollIntoView({ block: 'center', behavior: 'smooth' });
          } else {
            if (response.hosted_page.type === 'paid') {
              showPayNowMainStepFour(selectedPlanName, selectedPlanAmount, account.email);
            } else {
              window.location.href = response.hosted_page.url;
            }
          }
        })
      })
    }
  } else {
    Toastify({
      text: 'An error occured',
      duration: 3000,
      newWindow: true,
      gravity: "top",
      position: "center",
      style: {
        background: 'red',
        color: 'white'
      },
    }).showToast();

    showPayNowMainStepTwo(payNowStepOneData, payNowStepOneResponse);
  }
}

const showPayNowMainStepFour = (planName, planAmount, userEmail) => {
  const payNowStepThree = document.getElementById('pay-now-main-step-three');
  const payNowStepFour = document.getElementById('pay-now-main-step-four');
  const payNowStepFourPaymentDetailsSubscriptionInfo = document.getElementById('pay-now-main-step-four-payment-details-subscription-info');
  const payNowStepFourPaymentDetailsAmountPaid = document.getElementById('pay-now-main-step-four-payment-details-amount-paid');
  const payNowStepFourPaymentDetailsProcessedOn = document.getElementById('pay-now-main-step-four-payment-details-processed-on');
  const payNowStepFourReceiptInfoEmailDisplay = document.getElementById('pay-now-main-step-four-receipt-info-email-display');
  const payNowMainStepFourFooterDoneButton = document.getElementById('pay-now-main-step-four-footer-done-button');

  payNowStepThree.style.display = 'none';
  payNowStepFour.style.display = 'flex';

  const date = new Date();

  payNowStepFourPaymentDetailsSubscriptionInfo.innerText = planName;
  payNowStepFourPaymentDetailsAmountPaid.innerText = `$${planAmount}`;
  payNowStepFourPaymentDetailsProcessedOn.innerText = `${date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })} · ${date.toLocaleTimeString('en-US', { timeStyle: 'short' })}`;
  payNowStepFourReceiptInfoEmailDisplay.innerText = userEmail;

  payNowMainStepFourFooterDoneButton.addEventListener('click', showPayNowMain);
}

const showPayNowConfirmationPopupContainer = () => {
  const payNowConfirmationPopupContainer = document.getElementById('pay-now-confirmation-popup-container');
  payNowConfirmationPopupContainer.style.display = 'flex';
}

const hidePayNowConfirmationPopupContainer = () => {
  const payNowConfirmationPopupContainer = document.getElementById('pay-now-confirmation-popup-container');
  payNowConfirmationPopupContainer.style.display = 'none';
}

const openPayNowConfirmationPopupMain = (subscription, continueCallback) => {
  const payNowConfirmationPopupMain = document.getElementById('pay-now-confirmation-popup-main');
  const payNowConfirmationPopupMainDate = document.getElementById('pay-now-confirmation-popup-main-date');
  const confirmButton = document.getElementById('pay-now-confirmation-popup-confirm-button');

  payNowConfirmationPopupMain.style.display = 'flex';
  payNowConfirmationPopupMainDate.innerText = `(${getDateStringWithoutYearFromTimestamp(subscription.next_billing_at)} - ${getDateStringPlusOneMonthWithoutYearFromTimestamp(subscription.next_billing_at)})`

  confirmButton.addEventListener('click', () => {
    continueCallback();
    hidePayNowConfirmationPopupContainer();
  });
}

const closePayNowConfirmationPopupMain = () => {
  const payNowConfirmationPopupMain = document.getElementById('pay-now-confirmation-popup-main');
  payNowConfirmationPopupMain.style.display = 'none';
}

window.addEventListener('DOMContentLoaded', () => {
  const payNowMainContainer = document.getElementById('pay-now-main-container');
  const headerPayNowButton = document.getElementById('header-pay-now-button');
  const payNowStepOne = document.getElementById('pay-now-main-step-one');
  const payNowStepOneForm = document.getElementById('pay-now-main-step-one-form');
  const payNowStepOneFormButton = document.getElementById('pay-now-main-step-one-form-button');

  payNowStepOneForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const data = Object.fromEntries(formData.entries());

    if (!validateEmail(data.email)) {
      Toastify({
        text: "Error: Invalid email address",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      return;
    }

    payNowStepOneFormButton.disabled = true;
    payNowStepOneFormButton.innerHTML = `<div class="bar-loader"></div>`

    let response = await fetch(
      `${api.emailLookupEndpoint}?email=${data.email}`,
      {
        headers: {
          'Authorization': 'whY-tSR2E12Y9QEIaZ9z'
        }
      }
    );

    if (response.status === 200) {
      response = await response.json();
      payNowStepOneData = data;
      payNowStepOneResponse = response;

      if (response.error_code) {
        Toastify({
          text: `Error: ${response.message}`,
          duration: 3000,
          newWindow: true,
          gravity: "top",
          position: "center",
          style: {
            background: 'red',
            color: 'white'
          },
        }).showToast();

        payNowStepOneFormButton.disabled = false;
        payNowStepOneFormButton.innerHTML = 'PAY NOW';
      } else {
        showPayNowMainStepTwo(data, response);
      }
    } else {
      alert('An error occured')
    }
  });

  const payNowConfirmationPopupContainer = document.getElementById('pay-now-confirmation-popup-container');

  payNowConfirmationPopupContainer.addEventListener('click', hidePayNowConfirmationPopupContainer)

  const payNowConfirmationPopupMain = document.getElementById('pay-now-confirmation-popup-main');
  const payNowConfirmationPopupMainCloseButton = document.getElementById('pay-now-confirmation-popup-main-close-button');
  const payNowConfirmationPopupMainCloseTriggers = document.querySelectorAll('.pay-now-confirmation-popup-close-trigger');

  payNowConfirmationPopupMainCloseButton.addEventListener('click', hidePayNowConfirmationPopupContainer)
  payNowConfirmationPopupMain.addEventListener('click', (e) => e.stopPropagation());

  payNowConfirmationPopupMainCloseTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      hidePayNowConfirmationPopupContainer();
    });
  });
});
